var localization = {
    searchfilter: "Sorry, we couldn't find any results. Try modifying your criteria.",
    insufficientdata: 'Sorry, our data seems to be incomplete or lacking the necessary information to show you anything at this time.',
    error: 'Something went wrong! We encountered an error and are unable to process your request at this time.',
    takeaction: 'This is a custom message to tell you what action to take.',
    noworkneeded: 'Great! You currently have no more items remaining needing attention.',
    unauthorized: 'Sorry, you do not have access rights to this data.',
};
export default localization;
